import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addProvider = (provider, token) => {
  const config = configurationForToken(token);
  return apiClient.post("/admin/provider/create", provider, config);
};

const updateProvider = (provider, id, token) => {
  const config = configurationForToken(token);
  return apiClient.put(`/admin/provider/${id}/edit`, provider, config);
};

const deleteProvider = (providerId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete(`/admin/provider/${providerId}/delete`, config );
};

const allProviders = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/provider/all", config);
};

export default {
  addProvider,
  updateProvider,
  deleteProvider,
  allProviders,
};



// WEBPACK FOOTER //
// ./src/Services/ProviderService.js